import React, { useState } from "react";
import classes from "./location.module.css";
import {
  Card,
  CardContent,
  Avatar,
  Badge,
  Chip,
  Typography,
  Button,
} from "@mui/material";
import {
  checkOnline,
  generateColor,
  getChipColor,
  stringAvatar,
  formatStatusLabel,
} from "../../../utilities/commonFunctions";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { LOCATION } from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { saveLocationList } from "../../../Redux/actions/location-action";

// Future day of a repeating task (is_projected) — not created yet.
const SCHEDULED_CHIP = {
  backgroundColor: "#EFF6FF",
  color: "#256FE8",
  fontSize: "13px",
};

const LocationCard = ({
  item,
  index,
  handleCardClick,
  ln,
  fromDate,
  setUpdateState,
  toDate,
}) => {
  console.log(item, ".>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [isOnline, setIsOnline] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { teamMembersList } = useSelector((state) => state.allUsers);

  const handleViewRoute = (event, item) => {
    event.stopPropagation(); // Prevent card click event from firing
    navigate(`/maps/location-view-route/${item.slug.toLowerCase()}`);
  };

  const handleNotReached = async (event, item) => {
    try {
      event.stopPropagation(); // Prevent card click event from firing
      const { data } = await authApi.put(
        `${LOCATION}/mark-not-reached/${item._id}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      setUpdateState(data);
    } catch (error) {
      console.log(error);
    }
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const getLocations = async () => {
    const userEntry = {};

    try {
      const { data } = await authApi.post(
        `${LOCATION}?start_date=${moment(fromDate).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(toDate).format("YYYY-MM-DD")}&view_all=${true}`,
        userEntry,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      dispatch(saveLocationList(data));
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  // useEffect(() => {
  //   checkOnline( item?.teamMember?._id);
  // }, [teamMembersList, item]);

  return (
    <div key={index}>
      <Card
        key={index}
        className={classes.teamCard}
        onClick={(e) => handleCardClick(e, item)}
      >
        <CardContent
          sx={{ paddingBottom: "16px !important" }}
          className={classes.teamCardContent}
        >
          <div className={classes.locationGridCardHeader}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px",
              }}
            >
              <Badge
                color={
                  checkOnline(item?.teamMember?._id) === "checkin"
                    ? "success"
                    : "error"
                }
                badgeContent=" "
                // variant="dot"
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                className={classes.LocationOnlineBadge}
              >
                {item?.teamMember &&
                item?.teamMember?.profile_pic &&
                item?.teamMember?.profile_pic?.filename ? (
                  <Avatar
                    alt={item.teamMember.name?.trim() || item.title}
                    src={`${process.env.REACT_APP_IMAGE_URL}/${item?.teamMember?.profile_pic?.destination}${item?.teamMember?.profile_pic?.filename}`}
                    sx={{ width: 44, height: 44 }}
                  />
                ) : (
                  <Avatar
                    {...stringAvatar(item?.teamMember?.name || item.title)}
                    sx={{
                      bgcolor: item.department_details?.[0]?.colour
                        ? item.department_details[0].colour
                        : `${generateColor(
                            item.teamMember.name || item.title
                          )}`,
                      width: "44px",
                      height: "44px",
                    }}
                  />
                )}
              </Badge>

              <div className={classes.memberCardText}>
                <Typography className={classes.memberCardTextHeading}>
                  {item.title}
                </Typography>
              </div>
            </div>
            <Chip
              className={classes.locationStatusChip}
              label={item.is_projected ? "Scheduled" : formatStatusLabel(item.status)}
              size="small"
              style={item.is_projected ? SCHEDULED_CHIP : getChipColor(item.status)}
            />
          </div>
          <hr className={classes.UnderlineHr} />
          <div className={classes.memberCardTextContainer}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Typography className={classes.form_lable}>
                  {ln.team_member}
                </Typography>
                <Typography className={classes.memberCardTextHeading}>
                  {item.teamMember.name}
                </Typography>
              </div>
              {item.status === "rejected" ? (
                <div>
                  <Typography className={classes.form_lable}>
                    {ln.rejected_reason}
                  </Typography>
                  <Typography className={classes.memberCardTextHeading}>
                    {item?.user_location?.rejection_notes.length > 11
                      ? `${item?.user_location?.rejection_notes.substring(
                          0,
                          11
                        )}...`
                      : item?.user_location?.rejection_notes}
                  </Typography>
                </div>
              ) : null}
            </div>
            <div>
              <Typography className={classes.form_lable}>
                {ln.assigned_on}
              </Typography>
              <Typography className={classes.memberCardTextHeading}>
                {moment(item.assigned_on).format("DD MMM YYYY,hh:mm A")}
              </Typography>
            </div>
          </div>
          <hr className={classes.UnderlineHr} />
          <div className={classes.memberCardBtnSection}>
            {item.is_projected ? (
              // A future day of a repeating task: created automatically that day.
              <Typography sx={{ fontSize: 13, color: "#6A6E8A", textAlign: "center" }}>
                Repeating task · assigned automatically on{" "}
                {moment(item.assigned_on).format("D MMM")}
              </Typography>
            ) : item.status === "completed" ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    width: "45%",
                  }}
                  className={classes.locationCardButton}
                  onClick={(event) => handleViewRoute(event, item)}
                >
                  {ln.view_route}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  size="small"
                  style={{
                    width: "45%",
                  }}
                  className={classes.locationCardButton}
                  onClick={(event) => handleNotReached(event, item)}
                >
                  {ln.not_reached}?
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth
                  className={classes.locationCardButton}
                  onClick={(event) => handleViewRoute(event, item)}
                >
                  {ln.view_route}
                </Button>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LocationCard;
